export default __webpack_public_path__ + "static/media/mask-icon.9f1b7b39.svg";